"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlInfo = exports.getFilenameInfo = exports.generateResource = exports.generateGenericResource = exports.generateImageResource = exports.generateImageQueryUrl = exports.remapCloudFrontRequest = exports.getKeyInfo = void 0;
var get_key_info_1 = require("./get-key-info");
Object.defineProperty(exports, "getKeyInfo", { enumerable: true, get: function () { return get_key_info_1.getKeyInfo; } });
var remap_viewer_request_1 = require("./remap-viewer-request");
Object.defineProperty(exports, "remapCloudFrontRequest", { enumerable: true, get: function () { return remap_viewer_request_1.remapCloudFrontRequest; } });
var generate_image_query_url_1 = require("./generate-image-query-url");
Object.defineProperty(exports, "generateImageQueryUrl", { enumerable: true, get: function () { return generate_image_query_url_1.generateImageQueryUrl; } });
var generate_resource_1 = require("./generate-resource");
Object.defineProperty(exports, "generateImageResource", { enumerable: true, get: function () { return generate_resource_1.generateImageResource; } });
Object.defineProperty(exports, "generateGenericResource", { enumerable: true, get: function () { return generate_resource_1.generateGenericResource; } });
Object.defineProperty(exports, "generateResource", { enumerable: true, get: function () { return generate_resource_1.generateResource; } });
var get_filename_info_1 = require("./get-filename-info");
Object.defineProperty(exports, "getFilenameInfo", { enumerable: true, get: function () { return get_filename_info_1.getFilenameInfo; } });
var get_url_info_1 = require("./get-url-info");
Object.defineProperty(exports, "getUrlInfo", { enumerable: true, get: function () { return get_url_info_1.getUrlInfo; } });
__exportStar(require("./utils"), exports);
__exportStar(require("./types"), exports);
